module.exports = __webpack_public_path__ + "static/media/git_sh.43f253c1.png";